import { useTranslate } from '@va/localization';
import { MultiSelectFilter, TextFilter } from '@va/shared/feature-filters';
import { ApiOperators, FilterOperators } from '@va/types/filters';
import { useMemo } from 'react';
import { useCountryOptions } from '../filter-options';
import { FilterHook } from '../types';

export const useCitiesFilter: FilterHook<typeof TextFilter> = (params) => {
  const translate = useTranslate();

  return useMemo(
    () =>
      new TextFilter({
        id: 'cityName',
        name: 'cityName',
        label: translate('filter.cityName'),
        operator: FilterOperators.contains,
        operatorOptions: [FilterOperators.contains, FilterOperators.doesNotContain, FilterOperators.is],
        operatorMapper: (operator) => {
          switch (operator) {
            case FilterOperators.contains:
              return ApiOperators.in;
            case FilterOperators.doesNotContain:
              return ApiOperators.notIn;
            case FilterOperators.is:
              return ApiOperators.eq;
            default:
              return ApiOperators.in;
          }
        },
        ...params,
        inputProps: { placeholder: translate('filters.placeholder.cityName'), ...params?.inputProps },
      }),

    [translate, params],
  );
};

export const useCountriesFilter: FilterHook<typeof MultiSelectFilter> = (params) => {
  const translate = useTranslate();
  const countryOptions = useCountryOptions();

  return useMemo(
    () =>
      new MultiSelectFilter({
        id: 'countryCode',
        name: 'countryCode',
        label: translate('filter.countryName'),
        operator: FilterOperators.is,
        operatorOptions: [FilterOperators.is, FilterOperators.isNot],
        ...params,
        inputProps: {
          useOptions: () => ({ data: countryOptions }),
          showSearchInput: true,
          searchPlaceholder: translate('filters.placeholder.countryName'),
          ...params?.inputProps,
        },
      }),
    [countryOptions, params, translate],
  );
};

export const useIpFilter: FilterHook<typeof TextFilter> = (params) => {
  const translate = useTranslate();

  return useMemo(
    () =>
      new TextFilter({
        id: 'ip',
        name: 'ip',
        label: translate('filter.ip'),
        operator: FilterOperators.contains,
        operatorOptions: [FilterOperators.contains, FilterOperators.doesNotContain],
        ...params,
        inputProps: { placeholder: translate('filters.placeholder.ip'), ...params?.inputProps },
      }),
    [params, translate],
  );
};
